<!--
무자료확인 > 스캔 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-height-1-1 uk-flex uk-flex-column" @click="focus">
        <div class="uk-margin-auto-vertical uk-text-center">

            <!-- 입력검증 메세지 -->
            <div class="uk-text-large3 uk-text-danger" v-show="isEmptyScan">
                입력된 값이 없습니다
            </div>


            <!-- 입고결과 안내 -->
            <div class="result" :class="resultClass" v-show="scan">
                <div class="title">
                    {{ classficationText }}
                </div>

                <!-- 입고경과일 안내 -->
                <div class="days-from-ship-in" v-if="shipIn">
                    <div>
                        <b >{{ shipIn.over_days_msg }}</b>
                    </div>
                    입고일 : {{ shipIn.created_at_local }}
                </div>
            </div>

            <!-- 무자료 등록 안내 -->
            <div class="register-nodata-guide" v-show="needRegisterNodata">
                무자료를 등록하세요 <b>({{ shipinOverdays }}일 경과)</b>
            </div>



            <!-- 스캔 모듈 -->
            <div class="scan-input" :class="scanInputClass">
                <div class="title">
                    <i class="material-icons">
                        aspect_ratio
                    </i>
                    무자료 BOX를 스캔하세요
                </div>


                <div>
                    <input
                        type="text"
                        ref="scan"
                        placeholder="SCAN, HERE"
                        autofocus
                        @keyup.enter="scanning"
                    />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 현재 스캔된 정보
             */
            scan: {
                type: Object,
                default: null,
            },

            /**
             * 무자료등록 기준일
             */
            nodataOverdaysFromShipin: {
                type: Number,
            },

        },
        data: function () {
            return {
                // (bool) 빈값을 엔터쳤을때 경고문구 출력여부
                isEmptyScan: false,


            };
        },
        computed: {

            /**
             * 분류결과
             **/
            classficationText() {
                if (! this.scan) {
                    return null;
                }

                if (this.scan.trackings.length === 1) {
                    return 'NORMAL';
                } else if (this.scan.trackings.length > 1) {
                    return 'MULTI MATCH';
                } else if (this.scan.trackings.length === 0) {
                    return 'NO DATA';
                }
            },

            /**
             * 스캔 input 클래스
             **/
            scanInputClass() {
                return {
                    'has-result': this.scan,
                };
            },

            /**
             * 결과부분 클래스
             **/
            resultClass() {
                return {
                    'has-warning': this.scan !== null && this.scan.trackings.length === 0,
                };
            },

            /**
             * 입고정보
             **/
            shipIn() {
                if (this.scan && this.scan.ship_in) {
                    return this.scan.ship_in;
                }

                return null;
            },

            /**
             * 무자료 등록여부
             * @return boolean
             **/
            needRegisterNodata() {
                return this.getNeedRegisterNodata(this.scan);
            },

            /**
             * 입고경과일
             * @return integer
             **/
            shipinOverdays() {
                return this.getShipinOverdays(this.scan);
            },

        },

        methods: {
            /**
             * 스캔 input 에 포커스를 줌
             */
            focus: function () {
                this.$refs.scan.focus();
            },

            /**
             * 스캔처리
             */
            scanning: function () {
                let scan_no = this.$refs.scan.value;

                // 검증
                this.isEmptyScan = ! scan_no;
                if (this.isEmptyScan) {
                    return;
                }

                /**
                 * 입력한 값으로 트래킹 조회
                 */
                let load = new Promise((resolve, reject) => {
                        //reject('failed !');

                        // ajax 옵션
                        let opts = {
                            type: 'get',
                            url: '/regions/' + this.regionId + '/trackings',
                            contentType: 'application/json',
                            data: {
                                scan_no,
                            },
                            success: (response, textStatus, jqXHR) => {
                                // promise 성공
                                resolve(response);
                            },
                        };

                        // ajax 실행
                        $.app.ajax.module.default(opts);
                    });


                // promise 처리
                load.then((response) => {
                    // 조회
                    let ship_in = response.ship_in;
                    let trackings = response.trackings;
                    let select_no = response.select_no;
                    let selected_index = response.selected_index;

                    // 스캔결과 이벤트 발생
                    let scan = {
                        scan_no,
                        ship_in,
                        trackings,
                        selected_index
                    };
                    this.$emit('update:scan', scan);

                    // input 초기화
                    this.$refs.scan.value = null;

                    // 결과표시

                });



            },

            /**
             * 입고경과일 계산
             * @param scan (object)
             * @return integer
             **/
            getShipinOverdays(scan) {
                if (scan && scan.ship_in) {
                    return scan.ship_in.over_days;
                }

                return 0;
            },

            /**
             * 무자료 등록여부 계산
             * @param scan (object)
             * @return boolean
             **/
            getNeedRegisterNodata(scan) {
                if (! scan) {
                    return false;
                }

                if (scan.trackings.length > 0) {
                    return false;
                }

                // 무자료등록 기준일 경과했는지 판단
                return  this.getShipinOverdays(scan) >= this.nodataOverdaysFromShipin;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .scan-input {
        .title {
            font-size: 2rem;
            .material-icons {
                font-size: 44px;
            }
        }

        input {
            font-size: 2rem;
            height: 80px;
            width: 80%;
            margin: 40px 0;
            text-align: center;
        }

        &.has-result {
            .title {
                font-size: 1.5rem;
                text-align: left;
                width: 80%;
                display: inline-block;

                .material-icons {
                    font-size: 30px;
                }
            }

            input {
                margin: 10px 0;
            }

            margin-bottom: 30px;
        }
    }

    .result {
        margin-bottom: 30px;
        color: #fff;
        background-color: #0f7ae5;
        padding: 30px;

        .title {
            font-size: 4rem;
            font-weight: bold;
            padding: 10px;
        }

        &.has-warning {
            background-color: #ee395b;
        }
    }

    // 입고경과일 안내
    .days-from-ship-in {
        font-size: 1.5rem;
        b {
            font-size: 2rem;
        }
    }

    // 무자료등록 안내
    .register-nodata-guide {
        margin-top: -30px;
        margin-bottom: 30px;
        color: #ee395b;
        background-color: #FFFD7C;
        padding: 30px;
        font-size: 4rem;
    }
</style>